<template>
  <bkf-icon>
    <v-tooltip
      bottom
    >
      <template #activator="{ on, attrs }">
        <v-icon
          :color="color"
          v-bind="attrs"
          v-on="on"
        >
          {{ icon }}
        </v-icon>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
  </bkf-icon>
</template>

<script>

export default {
  props: {
    status: {
      default: null,
      required: false,
      type: String,
    },
  },
  data() {
    return {
      icons: {
        ERROR: 'mdi-progress-alert',
        NEW: 'mdi-progress-star',
        PROCESS: 'mdi-progress-clock',
        DONE: 'mdi-check-circle-outline',
        DEFAULT: 'mdi-help-circle-outline',
      },
      colors: {
        ERROR: 'error',
        NEW: 'gray',
        PROCESS: 'progress',
        DONE: 'green darken-2',
        DEFAULT: 'gray',
      },
      texts: {
        ERROR: this.$trans('reports-v3.file-status.progressError'),
        NEW: this.$trans('v2.fm2.reports-v3.file-status.progressNew'),
        PROCESS: this.$trans('v2.fm2.reports-v3.file-status.process'),
        DONE: this.$trans('v2.fm2.reports-v3.file-status.done'),
      },
    };
  },
  computed: {
    icon() {
      if (this.status in this.icons) {
        return this.icons[this.status];
      }
      return this.icons.DEFAULT;
    },
    text() {
      if (this.status in this.texts) {
        return this.texts[this.status];
      }
      return this.texts.DEFAULT;
    },
    color() {
      if (this.status in this.colors) {
        return this.colors[this.status];
      }
      return this.colors.DEFAULT;
    },
  },
};
</script>
